import { Box, Paper } from '@mui/material'
import DescriptionList from 'components/DescriptionList'
import Header from 'components/Header'
import { useAPI } from 'contexts/APIProvider'
import WorkReference from 'logic/WorkReference'
import AdminNurseDetailContext from 'pages/AdminNurseDetail/context'
import React from 'react'

const AdminNurseWorkReferences: React.FC = () => {
  const { nurse } = React.useContext(AdminNurseDetailContext)
  const { api } = useAPI()
  const [workReferences, setWorkReferences] = React.useState<WorkReference[]>([])

  const fetchWorkReferences = React.useCallback(async () => {
    const workReferences = await api.listWorkReferences({ nurse_id: nurse.nurse_id, sideloads: ['nurse'] })
    setWorkReferences(workReferences)
  }, [api, nurse.nurse_id])

  React.useEffect(() => {
    fetchWorkReferences()
  }, [fetchWorkReferences])

  
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {workReferences.map((workReference) => (
        <Paper key={workReference.id} sx={{ padding: 2 }}>
            <DescriptionList labelWidth='300px' data={[{ 
              label: 'Reference From', 
              value: workReference.reference_name 
            }, { 
              label: 'Patient Communication', 
              value: workReference.patient_communication 
            }, { 
              label: 'Scaling and Polishing', 
              value: workReference.scaling_and_polishing 
            }, { 
              label: 'Infection Control Procedures', 
              value: workReference.infection_control_procedures 
            }, { 
              label: 'Record Keeping and Documentation', 
              value: workReference.record_keeping_and_documentation 
            }, { 
              label: 'Time Management', 
              value: workReference.time_management 
            }, { 
              label: 'Teamwork and Collaboration', 
              value: workReference.teamwork_and_collaboration 
            }, { 
              label: 'Professionalism', 
              value: workReference.professionalism 
            }, { 
              label: 'Comments', 
              value: workReference.comments,
              sx: { whiteSpace: 'pre-line' }
            }, {
              label: 'Created At',
              value: workReference.created_at.toFormat('LLL dd, yyyy - hh:mm a')
            }]} />
        </Paper>
    ))}
    </Box>
  )
}

export default AdminNurseWorkReferences